// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"c10a78d3","145":"6a756d05","269":"c526def8","289":"de43a153","453":"ea7afc41","513":"55618280","530":"864e962c","542":"8009c2ad","555":"24f29950","630":"1fe25fc4","657":"4c31d9c3","667":"379448ed","670":"7ae679a9","766":"be45d6b2","900":"a94b68b5","980":"9c0f9d39"}[chunkId] + ".chunk.js";
};